import { React, useState, useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../auth.jsx";
import "./login.css";
import api from "../../api.js";
import md5 from "md5";
import Loading from "../../components/loading/loading.js";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import CryptoJS from "crypto-js";

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

function Login() {
  const [usuario, setusuario] = useState("");
  const [senha, setSenha] = useState("");
  const { setLogado } = useContext(AuthContext);
  const [sucesso, setSucesso] = useState("N");
  const [cliente, setCliente] = useState("S");
  const senhaHashF = md5(senha.toUpperCase());
  const senhaHashC = md5(senha);

  function encryptData(data) {
    return CryptoJS.AES.encrypt(data.toString(), "AFM-Distrato").toString();
  }

  const type =
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
      ? "cardMobile"
      : "cardWeb";

  function LoginUsuario() {
    Loading.show("Aguarde...");
    if (usuario === "" || senha === "") {
      Loading.hide();
      toastr.warning("Usuário e Senha Devem Ser Preenchidos", "Atenção");
    } else {
      api
        .post("/login", { USUARIO: usuario, SENHA: senhaHashC })
        .then(function (AxiosResponse) {
          Loading.hide();
          if (AxiosResponse.data.SUCCESS !== true) {
            toastr.error(
              "Usuário ou Senha Incorreto",
              "Erro ao realizar login!"
            );
          } else if (AxiosResponse.data.SUCCESS === true) {
            sessionStorage.setItem(
              "id_usuario",
              encryptData(AxiosResponse.data.DATA[0].id_usuario)
            );
            sessionStorage.setItem(
              "usuario",
              encryptData(AxiosResponse.data.DATA[0].usuario)
            );
            sessionStorage.setItem(
              "razaoSocial",
              encryptData(AxiosResponse.data.DATA[0].nome)
            );
            setLogado(true);
            sessionStorage.setItem("logado", encryptData("S"));
            setSucesso("S");
            toastr.success(
              `Seja Bem Vindo ${AxiosResponse.data.DATA[0].nome}!`,
              "Sucesso."
            );
          }
        })
        .catch(function (error) {
          sessionStorage.setItem("logado", encryptData("N"));
          setLogado(false);
          Loading.hide();
          toastr.error(error, "Erro ao realizar login!");
        });
    }
  }

  function EnterTab(event) {
    if (event.keyCode === 13) {
      document.getElementById("floatingPassword").focus();
    }
  }

  function EnvioEnter(event) {
    if (document.getElementById("floatingPassword")) {
      if (event.keyCode === 13) {
        LoginUsuario();
      }
    }
  }

  function alterarUsuario(event) {
    setusuario(event.target.value);
  }

  function alterarSenha(event) {
    setSenha(event.target.value);
  }

  return (
    <div className="fundoLogin">
      <div className="container-fluid">
        <div className={`card ${type} pt-3 ps-2 pe-2 mt-3  altResponsive`}>
          <div className="align-items-center text-center form-container">
            <form className="form-signin w-100 m-auto">
              <img
                className="mb-2 mt-5 text-center"
                src="../../img/logotipoafm.png"
                width={"360px"}
                alt=""
              />
              <h1 className="h3 mb-3 fw-normal">Login</h1>

              <div className="form-floating">
                <input
                  onChange={alterarUsuario}
                  onKeyDown={EnterTab}
                  type="text"
                  className="form-control edtEmail"
                  id="floatingInput"
                  placeholder="Usuário"
                />
                <label for="floatingInput">Usuário</label>
              </div>
              <div className="form-floating mt-2">
                <input
                  onChange={alterarSenha}
                  onKeyDown={EnvioEnter}
                  type="password"
                  className="form-control edtSenha"
                  id="floatingPassword"
                  placeholder="Senha"
                />
                <label for="floatingPassword">Senha</label>
              </div>

              <div className="form-floating mt-2">
                <button
                  onClick={() => LoginUsuario()}
                  className="btnLogin w-100 btn btn-lg mt-1"
                  type="button"
                >
                  Acessar
                </button>
              </div>

              {sucesso === "S" ? <Navigate to="/admin/home" /> : null}
              {/* <div className="mt-1 mb-5">
                            <Link to="/esquecisenha" className="nav-link active esquecisenha">Esqueci Senha</Link>
                        </div> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
